$(document).ready(() => {
  const options = {
    enableHighAccuracy: false,
    timeout: 50000,
    maximumAge: 0
  };
  const userLat = Cookies.get('user_lat') || '';
  const userLng = Cookies.get('user_lng') || '';
  const bluebookSearchGeo = 'off';

  const getGeolocation = () => {
    const zipCode = Cookies.get('user_zip') || '';
    if(!isSafari() || !zipCode)
      return navigator.geolocation.getCurrentPosition(geolocationSuccess, geolocationError, options);
  }

  const isSafari = ()=> {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }


  const geolocationSuccess = (position) => {
    const coordinates = position.coords;
    const zipCode = Cookies.get('user_zip') || '';
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coordinates.latitude},${coordinates.longitude}&key=AIzaSyBamZ8DCHpCpD1RpoWKZ_oYgwCjqoXeDnE`;

    Cookies.set('user_lat', coordinates.latitude, { expires: 365, path: '/' });
    Cookies.set('user_lng', coordinates.longitude, { expires: 365, path: '/' });

    if (!zipCode) {
      $.ajax({
        type: "GET",
        url: url,
        dataType: "json",
        success: (response) => {
          response.results[0].address_components.forEach((addressComponent) => {
            if (addressComponent.types.includes('postal_code')) {
              Cookies.set('user_zip', addressComponent.long_name, { expires: 365, path: '/' });
            }
          });
        }
      });
    }

    (!userLat || !userLng) && window.location.reload();
  }

  const geolocationError = (error) => {
    if (error.code == 1) {
      Cookies.set('user_lat', '', { expires: 365, path: '/' });
      Cookies.set('user_lng', '', { expires: 365, path: '/' });

      // (userLat || userLng) && window.location.reload();
    }
  }

  const init = () => {
    bluebookSearchGeo == 'on' && getGeolocation();
  }

  init();
});
